import { useTranslation } from 'react-i18next';
import { Grid, Paper, Box, Divider, Button } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { useState, useCallback, useEffect } from 'react';
import { District } from 'src/shared/models/district/district';
import { Association } from 'src/shared/models/association/association';
import { UserStatusEnum } from 'src/shared/models/enums/userStatus.enum';
import { useGlobals } from 'src/shared/contexts/appContext';
import SearchField from 'src/shared/components/form/searchField';
import { PersonAdd } from '@mui/icons-material';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { UserDataGrid } from '../components/userDataGrid';
import { UserCreateModal } from '../components/userCreateModal';

export const UserListPage = () => {
  const [, setLoading] = useState(false);

  const { setDateStamp, currentUser } = useGlobals();

  const [searchString, setSearchString] = useState<string>('');
  const [tempSearchString, setTempSearchString] = useState<string>('');
  const [association] = useState<Association>();
  const [district] = useState<District>();
  const [status] = useState<number[]>([UserStatusEnum.Active]);

  const [createMode, setCreateMode] = useState<boolean>(false);

  const { t } = useTranslation(['user']);

  const loadingCallback = useCallback((isLoading: boolean) => {
    setLoading(isLoading);
  }, []);

  const handleSave = () => {
    setDateStamp(new Date());
    setCreateMode(false);
  };

  useEffect(() => {
    if (tempSearchString === '') {
      setSearchString('');
    }
    if (tempSearchString.length >= 2) {
      setSearchString(tempSearchString);
    } else {
      setSearchString('');
    }
  }, [tempSearchString]);

  return (
    <>
      <GridWrapper>
        <Grid item xs={12} md={6}>
          <MainContentHeader title={t('user:listUserHeader')} />
        </Grid>
        <Grid item xs={12} md={6} style={{ display: 'flex', justifyContent: 'flex-end', gridColumnGap: '5px' }}>
          {getPermission(currentUser, PermissionEnum.UserCreate) && (
            <Button onClick={() => setCreateMode(true)} variant='contained' color='primary' startIcon={<PersonAdd />} disableElevation>
              {t('user:createNewUserButton')}
            </Button>
          )}
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  p: 2,
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <SearchField onSearch={(newSearchString) => setTempSearchString(newSearchString)} />
              </Box>
              {/* <Box
                sx={{
                  p: 2,
                  display: 'flex',
                  alignItems: 'center',
                  '& .MuiInputLabel-formControl': {
                    backgroundColor: 'white',
                    px: '5px',
                  },
                }}
              >
                <Divider orientation='vertical' flexItem sx={{ mx: 2, my: -2 }} />
                <AssociationAndDistrictSelect
                  association={association}
                  district={district}
                  hideDistrict={false}
                  associationCallback={(val) => setAssociation(val || undefined)}
                  districtCallback={(val) => setDistrict(val || undefined)}
                />
              </Box> */}
            </Box>
            {/* <Divider />
            <UserTabs disableAll={loading} status={status} callback={(val) => setStatus(val)} /> */}
            <Divider />
            {status.length > 0 && (
              <UserDataGrid
                loadingCallback={loadingCallback}
                searchString={searchString}
                associationId={association?.countyAss_id.toString()}
                districtId={district?.countyAss_id.toString()}
                status={status}
                disableOnClickRow={!getPermission(currentUser, PermissionEnum.UserUpdate)}
              />
            )}
          </Paper>
        </Grid>
      </GridWrapper>
      {createMode && <UserCreateModal onClose={() => setCreateMode(false)} onSave={() => handleSave()} modalOpen={createMode} />}
    </>
  );
};
